/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Customer_Invite_HintInputs */



/**
* | output |
* | --- |
* | "Send a fresh invitation link. Links expire after 24 hours, so an old one may no longer work." |
*
* @param {Partner_Customer_Invite_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_invite_hint = /** @type {((inputs?: Partner_Customer_Invite_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Invite_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuen Einladungslink senden. Links laufen nach 24 Stunden ab, ein älterer funktioniert möglicherweise nicht mehr.")
	return /** @type {LocalizedString} */ ("Send a fresh invitation link. Links expire after 24 hours, so an old one may no longer work.")
});